var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardElement } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import { elementAssets } from '../../utils/cards-metadata-assets';
import Accordion from '../common/accordion';
import ElementCheckbox from './element-checkbox';
export default function ElementForm(_a) {
    var value = _a.value, setValue = _a.setValue, availableElements = _a.availableElements;
    var t = useI18n().t;
    function onChange(element) {
        var _value = __spreadArray([], value, true);
        var index = _value.indexOf(element);
        if (index === -1) {
            _value.push(element);
        }
        else {
            _value.splice(index, 1);
        }
        setValue(_value);
    }
    var allElements = availableElements || Object.values(CardElement);
    return (_jsx(Accordion, { count: value.length, defaultValue: true, height: 128, title: t('filters.element'), children: _jsx(Container, { children: allElements.map(function (element) { return (_jsx(ElementCheckbox, { hidden: value.length > 0 && !value.includes(element), icon: elementAssets[element], noneSelected: value.length === 0, onChange: function () { return onChange(element); }, value: value.includes(element) }, element)); }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"])));
var templateObject_1;
